<!-- 资源下载中心 -->
<template>
  <div class="down_load_page">
    <div class="top">
      <!-- 名称和下载图片 -->
      <div class="content">
        <!-- 名称 -->
        <span class="text_down">程序蛙硬件课编程软件</span>
        <!-- 下载按钮 -->
        <div class="bt_down" @click.stop="dowloadFile">
          <i class="iconfont cloud-xiazai3"></i>
          <span>立即下载</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      downLoadUrl: "https://codefrog.zdwkj.com/croak/croak_cloud/api/assets/sszx/程序蛙硬件课编程软件.rar"
    };
  },
  methods: {
    //下载文件
    async dowloadFile() {
      // console.log("点击下载了");
      let index = this.downLoadUrl.lastIndexOf("/");
      let fileName = this.downLoadUrl.slice(index + 1);
      // 创建隐藏的可下载链接
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = this.downLoadUrl;
      // 保存下来的文件名
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      // 移除元素
      document.body.removeChild(a);
    }
  }
};
</script>
<style lang="scss" scoped>
.down_load_page {
  .top {
    position: relative;
    width: 100vw;
    min-width: 1920px;
    height: 506px;
    background: url("../../assets/img/down_bg.png") no-repeat;

    .content {
      position: absolute;
      display: flex;
      left: 360px;
      top: 130px;
      color: #434343;
      flex-direction: column;
      .text_down {
        font-size: 36px;
        font-weight: bold;
      }
      .bt_down {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-top: 53px;
        width: 280px;
        height: 78px;
        background: #ffd101;
        border-radius: 44px;

        i {
          font-size: 26px;
        }

        span {
          margin-left: 8px;
          font-size: 20px;
        }
      }
    }
  }
}
</style>
